import React, { useState, useEffect } from "react";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { plazaServices } from "../pages/tollPlaza/plazaReportService";
import NewUpload from "./NewUpload";
import JSZip from "jszip";
import imagineHomeService from "../pages/imagineHome/imagineHomeService";
import { ProgressBar } from "primereact/progressbar";

const SingleUpload = ({ serviceId, vendor, uploadType, skus, sku, setSKUValue, showToast }) => {
    const acceptedFormatImages = ".png,.jpg,.jpeg,.zip";
    // const acceptedFormat3DModel = ".mtl,.obj,.zip";
    const acceptedFormat3DModel = ".glb,.dwg";
    const [errorMsg, setErrorMsg] = useState(null);
    const [infoMsg, setInfoMsg] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [fileCountText, setFileCountText] = useState(null);
    const [images, setImages] = useState([]);
    const [modelFiles, setModelFiles] = useState([]);

    const onReset = (resetSKU = true) => {
        setErrorMsg(null);
        if (resetSKU) {
            setSKUValue(null);
        }
        setInfoMsg(null);
        setImages([]);
        setModelFiles([]);
        setFileCountText(null);
    };
    useEffect(() => {
        setErrorMsg(null);
        setImages([]);
        setModelFiles([]);
    }, [skus]);

    const getFileCountText = (totalFileCount) => {
        return `${totalFileCount} file${totalFileCount > 1 ? "s" : ""} selected.`;
    };
    const excludeFile = (zip, filename) => {
        // skip hidden/system files like __MACOSX/ or .DS_Store
        return filename.startsWith("__MACOSX/") || filename.startsWith(".") || zip.files[filename].dir;
    };
    const handleChange = async (e) => {
        onReset(false);
        const files = Array.from(e.target.files);

        if (!files || files.length === 0) return;
        const totalFileCount = files.length;

        if (uploadType === "images") {
            const validExtensions = /\.(png|jpe?g)$/i;
            let imageFiles = [];

            if (files.length === 1 && files[0].name.endsWith(".zip")) {
                // unzip and validate images
                try {
                    const zip = await JSZip.loadAsync(files[0]);
                    const zipImages = [];

                    for (const filename of Object.keys(zip.files)) {
                        // skip hidden/system files like __MACOSX/ or .DS_Store
                        if (excludeFile(zip, filename)) {
                            continue;
                        }
                        if (!validExtensions.test(filename)) {
                            setErrorMsg(`Invalid file type inside zip ${files[0].name}: ${filename}. Only PNG/JPG/JPEG allowed.`);
                            return;
                        } else {
                            const fileData = await zip.files[filename].async("blob");
                            zipImages.push(new File([fileData], filename, { type: fileData.type }));
                        }
                    }

                    if (zipImages.length === 0) {
                        setErrorMsg("ZIP must contain PNG/JPG/JPEG images only.");
                        return;
                    }
                    imageFiles = zipImages;
                } catch (err) {
                    setErrorMsg("Invalid ZIP file");
                    return;
                }
            } else {
                // direct upload
                imageFiles = files.filter((f) => validExtensions.test(f.name));
                if (imageFiles.length !== files.length) {
                    setErrorMsg("Only PNG/JPG/JPEG files are allowed.");
                    return;
                }
            }

            setImages(imageFiles);
            setFileCountText(getFileCountText(totalFileCount));
        }
        // else if (uploadType === "3D_model") {
        //     let modelFiles = [];

        //     if (files.length === 1 && files[0].name.endsWith(".zip")) {
        //         // unzip and check for .obj & .mtl
        //         try {
        //             const zip = await JSZip.loadAsync(files[0]);
        //             const extracted = {};

        //             for (const [filename, zipEntry] of Object.entries(zip.files)) {
        //                 // skip hidden/system files like __MACOSX/ or .DS_Store
        //                 if (excludeFile(zip, filename)) {
        //                     continue;
        //                 }
        // if (/\.obj$/i.test(filename)) {
        //     const blob = await zipEntry.async("blob");
        //     extracted.obj = new File([blob], filename, { type: blob.type });
        // } else if (/\.mtl$/i.test(filename)) {
        //     const blob = await zipEntry.async("blob");
        //     extracted.mtl = new File([blob], filename, { type: blob.type });
        // }
        //             }

        //             if (!extracted.obj || !extracted.mtl) {
        //                 setErrorMsg("ZIP must contain exactly one OBJ and one MTL file.");
        //                 return;
        //             }

        //             modelFiles = [extracted.obj, extracted.mtl];
        //         } catch (err) {
        //             setErrorMsg("Invalid ZIP file");
        //             return;
        //         }
        //     } else if (files.length === 2) {
        //         const objFile = files.find((f) => /\.obj$/i.test(f.name));
        //         const mtlFile = files.find((f) => /\.mtl$/i.test(f.name));

        //         if (!objFile || !mtlFile) {
        //             setErrorMsg("You must upload one OBJ and one MTL file.");
        //             return;
        //         }

        //         modelFiles = [objFile, mtlFile];
        //     } else {
        //         setErrorMsg("Upload either one ZIP (OBJ+MTL) or exactly two files (OBJ & MTL).");
        //         return;
        //     }

        //     setModelFiles(modelFiles);
        //     setFileCountText(getFileCountText(totalFileCount));
        // }
        // else if (uploadType === "3D_model") {
        //     // allowed file types inside zip
        //     const validExtensions = /\.(obj|mtl|png|jpe?g)$/i;
        //     let modelFiles = [];

        //     if (files[0].name.toLowerCase().endsWith(".zip")) {
        //         try {
        //             const zip = await JSZip.loadAsync(files[0]);
        //             const extracted = { obj: null, mtl: null, textures: [] };

        //             for (const [filename, zipEntry] of Object.entries(zip.files)) {
        //                 // skip hidden/system files like __MACOSX/, .DS_Store
        //                 if (excludeFile(zip, filename) || zipEntry.dir) {
        //                     continue;
        //                 }
        //                 if (!validExtensions.test(filename)) {
        //                     setErrorMsg(`Invalid file type inside ${files[0].name}: ${filename}. Only OBJ, MTL, PNG, JPG, JPEG allowed.`);
        //                     return;
        //                 }
        //                 if (/\.obj$/i.test(filename)) {
        //                     if (extracted.obj) {
        //                         setErrorMsg("ZIP must contain only one OBJ file.");
        //                         return;
        //                     }
        //                     const blob = await zipEntry.async("blob");
        //                     extracted.obj = new File([blob], filename, { type: blob.type });
        //                 } else if (/\.mtl$/i.test(filename)) {
        //                     if (extracted.mtl) {
        //                         setErrorMsg("ZIP must contain only one MTL file.");
        //                         return;
        //                     }
        //                     const blob = await zipEntry.async("blob");
        //                     extracted.mtl = new File([blob], filename, { type: blob.type });
        //                 } else if (/\.(png|jpe?g)$/i.test(filename)) {
        //                     const blob = await zipEntry.async("blob");
        //                     extracted.textures.push(new File([blob], filename, { type: blob.type }));
        //                 } else {
        //                     setErrorMsg(`Invalid file in ZIP: ${filename}. Only OBJ, MTL, PNG, JPG, JPEG are allowed.`);
        //                     return;
        //                 }
        //             }

        //             if (!extracted.obj || !extracted.mtl) {
        //                 setErrorMsg("ZIP must contain exactly one OBJ and one MTL file.");
        //                 return;
        //             }

        //             // Store obj, mtl, and textures (if any)
        //             modelFiles = [extracted.obj, extracted.mtl, ...extracted.textures];
        //         } catch (err) {
        //             console.error(err);
        //             setErrorMsg("Invalid ZIP file.");
        //             return;
        //         }
        //     } else {
        //         setErrorMsg("Upload must be a single ZIP containing OBJ, MTL, and optional PNG/JPG textures.");
        //         return;
        //     }

        //     setModelFiles(modelFiles);
        //     setFileCountText(getFileCountText(totalFileCount));
        // }
        else if (uploadType === "3D_model") {
            // allowed file types inside zip
            let modelFiles = [];

            try {
                const file = files[0];
                modelFiles.push(file);
            } catch (err) {
                console.error(err);
                setErrorMsg("Invalid GLB/DWG file.");
                return;
            }

            setModelFiles(modelFiles);
            setFileCountText(getFileCountText(totalFileCount));
        }
    };
    const handleFileUpload = async (e) => {
        e.target.blur();
        setUploading(true);
        setUploadProgress(0);
        setInfoMsg("Please keep this page open until the upload is complete.");

        try {
            const formData = new FormData();
            formData.append("serviceId", serviceId);
            formData.append("userID", localStorage.getItem("emailId"));
            formData.append("vendor", vendor);
            formData.append("sku", sku);
            formData.append("type", uploadType);

            if (uploadType === "images") {
                // multiple files
                images.forEach((file) => formData.append("images", file));
            } else {
                // formData.append("obj_file", modelFiles[0]);
                // formData.append("mtl_file", modelFiles[1]);
                // const imagesMedia = modelFiles.filter((file) => !file.name.toLowerCase().endsWith(".mtl") && !file.name.toLowerCase().endsWith(".obj"));
                // if (imagesMedia.length) {
                //     imagesMedia.forEach((file) => formData.append("texture_3D_files", file));
                // }
                const modelFileKey = modelFiles[0].name.toLowerCase().endsWith(".glb") ? "glb_file" : "dwg_file";
                formData.append(modelFileKey, modelFiles[0]);
            }

            const res = await imagineHomeService.uploadSKUMedia(formData, (progressEvent) => {
                const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                setUploadProgress(percent);
            });

            if (res && res.data.status === 200) {
                onReset();
                showToast("success", "Success", res.data.message);
            } else {
                showToast("error", "Error", res?.data?.message || "Error uploading file(s)");
            }
        } catch (error) {
            console.error("Error uploading file(s):", error);
            showToast("error", "Error", error?.message || "Error uploading file(s)");
        } finally {
            setUploading(false);
            setInfoMsg(null);
            setUploadProgress(0);
        }
    };

    return (
        <div className="mt-3">
            <div className="grid justify-content-center mb-3">
                <div className="col-6">
                    <label className="mb-2 font-Gerstner-ProgramRegular text-left block">SKU</label>
                    <Dropdown
                        disabled={!skus}
                        value={sku}
                        options={skus}
                        onChange={(e) => setSKUValue(e.value)}
                        placeholder="Select SKU"
                        filter
                        filterPlaceholder="Search SKU"
                        className="font-Gerstner-ProgramRegular w-full"
                        style={{
                            borderRadius: "20px",
                            border: "1px solid #9AAB89",
                            height: "3rem",
                        }}
                    />
                </div>
            </div>

            <NewUpload multiple={uploadType === "images" ? true : false} accept={uploadType === "images" ? acceptedFormatImages : acceptedFormat3DModel} onchange={handleChange} fileName={fileCountText} uploadTextClassName="font-larken  charcoal-color mt-3 mb-3 block text-xl"></NewUpload>

            {errorMsg ? (
                <p className="text-center text-sm font-Gerstner-ProgramRegular" style={{ color: "red" }}>
                    {errorMsg}
                </p>
            ) : null}
            {uploading && infoMsg ? (
                <p className="text-center font-bold text-lg font-Gerstner-ProgramRegular" style={{ color: "#f4a261" }}>
                    {infoMsg}
                </p>
            ) : null}
            {uploading && (
                <div className="grid justify-content-center">
                    <div className="col-4">
                        <ProgressBar value={uploadProgress} color="#9AAB89"></ProgressBar>
                        <label style={{ color: "#9AAB89", WebkitTextFillColor: "#9AAB89" }} className="mt-2 font-Gerstner-ProgramRegular text-center block">
                            <span className="font-bold text-md ">Uploading {uploadProgress}%</span>
                        </label>
                    </div>
                </div>
            )}
            <div className="grid justify-content-center align-items-center text-center mt-3" style={{ gap: "10px" }}>
                <div className="col-12 sm:col-6 md:col-3">
                    <Button
                        disabled={uploading || !skus || (uploadType === "images" && images.length === 0) || (uploadType === "3D_model" && modelFiles === 0)}
                        label="RESET"
                        className="p-button-rounded p-button-outlined font-Gerstner-ProgramRegular charcoal-color w-full"
                        style={{
                            letterSpacing: "1.44px",
                            borderColor: "#9AAB89",
                            color: "#9AAB89",
                        }}
                        onClick={(e) => {
                            e.target.blur();
                            onReset();
                        }}
                    />
                </div>

                <div className="col-12 sm:col-6 md:col-3">
                    <Button
                        disabled={uploading || errorMsg || !sku || !skus || (uploadType === "images" && !images.length) || (uploadType === "3D_model" && !modelFiles.length)}
                        label={uploadType === "images" ? "UPLOAD IMAGE" : "UPLOAD MODEL"}
                        className="p-button-rounded font-Gerstner-ProgramRegular charcoal-color w-full"
                        style={{
                            letterSpacing: "1.44px",
                            backgroundColor: "#9AAB89",
                            borderColor: "#9AAB89",
                        }}
                        onClick={(e) => handleFileUpload(e)}
                    />
                </div>
            </div>
        </div>
    );
};

export default SingleUpload;
